module.exports = __webpack_public_path__ + "img/next-icon.e5006657.svg";